var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-end": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "800px" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c("v-toolbar-title", [_vm._v("Add a new datum")]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          return _vm.clearForm()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-form",
                {
                  ref: "form",
                  staticStyle: { width: "100%" },
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function ($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid",
                  },
                },
                [
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { "pa-5": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Datum",
                                  rules: _vm.datumNameRules,
                                },
                                model: {
                                  value: _vm.datum,
                                  callback: function ($$v) {
                                    _vm.datum = $$v
                                  },
                                  expression: "datum",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: { label: "Description" },
                                model: {
                                  value: _vm.datumDescription,
                                  callback: function ($$v) {
                                    _vm.datumDescription = $$v
                                  },
                                  expression: "datumDescription",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  label: "Datum Type",
                                  items: [
                                    _vm.datumType.Height,
                                    _vm.datumType.Depth,
                                  ],
                                },
                                model: {
                                  value: _vm.datumTypeAdd,
                                  callback: function ($$v) {
                                    _vm.datumTypeAdd = $$v
                                  },
                                  expression: "datumTypeAdd",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.submit()
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("done"),
                          ]),
                          _vm._v(
                            _vm._s(_vm.$t("Button.Create")) + "\n          "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              return _vm.clearForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Close")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { color: "grey lighten-4" } },
        [
          _c(
            "v-snackbar",
            {
              staticStyle: { "text-align": "center" },
              attrs: { color: _vm.snackColor, timeout: null, top: "" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.snackMessage) + "\n      "),
              _c(
                "v-btn",
                {
                  attrs: { dark: "", flat: "" },
                  nativeOn: {
                    click: function ($event) {
                      _vm.snackbar = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Close")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }